<template>
<div class="card overflow-auto">
	<div class="card-header "></div>	
	<div class="centered col-sm-8">
		<router-link :to="{ name: 'register' }">
			<button class="btn btn-block pl-16 pr-16 mt-36 bg-color-grblue">{{$t("Sign up")}} <img src="@/assets/arrow-right.svg" class="color-purple"> </button>
		</router-link>
		<br>
		<router-link :to="{ name: 'login' }">
			<button class="btn bg-color-grblue btn-block pl-16 pr-16 "> {{$t("Login")}} <img src="@/assets/arrow-right.svg" class="color-purple"></button>
		</router-link>
	</div>
</div>
</template>

<script>
import store from '@/store'

export default {
	name: "Home",
	data() {
		return {
		}
    },
	async mounted() {
		if(!localStorage.getItem('locale')) {
			await this.$router.push({ name: 'language' });
		}

		await store.dispatch('checkAuth').then(async (res) => {
			if(res.success && res.user) {
				await this.$router.push({ name: 'dashboard', params: {lang: localStorage.getItem('locale')} });
			}
		}).catch(err => {
			//check auth failed - no response necessery
		});

	}
}
</script>
